module.exports = __webpack_public_path__ + "6d9226ae086912ab446526f2cdb880d0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/winter-chalet-empty.png
// module id = 335
// module chunks = 0